import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PipelineView = ({ candidates, onStatusChange, onViewProfile }) => {
  const [draggedCandidate, setDraggedCandidate] = useState(null);

  const stages = [
    { id: 'new', label: 'New Applications', icon: 'Inbox', color: 'bg-blue-100 border-blue-300' },
    { id: 'screening', label: 'Screening', icon: 'Search', color: 'bg-yellow-100 border-yellow-300' },
    { id: 'shortlisted', label: 'Shortlisted', icon: 'Star', color: 'bg-purple-100 border-purple-300' },
    { id: 'interview_scheduled', label: 'Interview', icon: 'Calendar', color: 'bg-indigo-100 border-indigo-300' },
    { id: 'offered', label: 'Offered', icon: 'Gift', color: 'bg-green-100 border-green-300' },
    { id: 'hired', label: 'Hired', icon: 'CheckCircle2', color: 'bg-emerald-100 border-emerald-300' }
  ];

  const getCandidatesByStage = (stageId) => {
    return candidates?.filter(candidate => candidate?.status === stageId);
  };

  const handleDragStart = (candidate) => {
    setDraggedCandidate(candidate);
  };

  const handleDragOver = (e) => {
    e?.preventDefault();
  };

  const handleDrop = (stageId) => {
    if (draggedCandidate && draggedCandidate?.status !== stageId) {
      onStatusChange(draggedCandidate?.id, stageId);
    }
    setDraggedCandidate(null);
  };

  return (
    <div className="overflow-x-auto pb-4">
      <div className="flex gap-4 min-w-max">
        {stages?.map((stage) => {
          const stageCandidates = getCandidatesByStage(stage?.id);
          return (
            <div
              key={stage?.id}
              className="flex-shrink-0 w-80"
              onDragOver={handleDragOver}
              onDrop={() => handleDrop(stage?.id)}
            >
              <div className={`${stage?.color} border-2 rounded-lg p-3 mb-3`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Icon name={stage?.icon} size={18} className="text-foreground" />
                    <h3 className="text-sm font-semibold text-foreground">{stage?.label}</h3>
                  </div>
                  <span className="px-2 py-1 bg-white rounded-full text-xs font-medium text-foreground">
                    {stageCandidates?.length}
                  </span>
                </div>
              </div>
              <div className="space-y-3 max-h-[600px] overflow-y-auto pr-2">
                {stageCandidates?.map((candidate) => (
                  <div
                    key={candidate?.id}
                    draggable
                    onDragStart={() => handleDragStart(candidate)}
                    className="bg-card border border-border rounded-lg p-3 cursor-move hover:shadow-md transition-smooth"
                  >
                    <div className="flex items-start gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-muted">
                        <Image
                          src={candidate?.avatar}
                          alt={candidate?.avatarAlt}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-medium text-foreground truncate mb-1">
                          {candidate?.name}
                        </h4>
                        <p className="text-xs text-muted-foreground truncate">
                          {candidate?.position}
                        </p>
                      </div>
                    </div>

                    <div className="space-y-2 mb-3">
                      <div className="flex items-center justify-between text-xs">
                        <span className="text-muted-foreground">Match</span>
                        <span className="font-medium text-primary">{candidate?.skillMatch}%</span>
                      </div>
                      <div className="flex items-center justify-between text-xs">
                        <span className="text-muted-foreground">Experience</span>
                        <span className="font-medium text-foreground">{candidate?.experience}</span>
                      </div>
                      <div className="flex items-center justify-between text-xs">
                        <span className="text-muted-foreground">Applied</span>
                        <span className="font-medium text-foreground">{candidate?.appliedDate}</span>
                      </div>
                    </div>

                    <Button
                      variant="outline"
                      size="sm"
                      fullWidth
                      iconName="Eye"
                      iconPosition="left"
                      onClick={() => onViewProfile(candidate?.id)}
                    >
                      View Profile
                    </Button>
                  </div>
                ))}

                {stageCandidates?.length === 0 && (
                  <div className="text-center py-8 text-muted-foreground">
                    <Icon name="Inbox" size={32} className="mx-auto mb-2 opacity-50" />
                    <p className="text-sm">No candidates</p>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PipelineView;